<template>
  <div class="profile-description-wrapper">
    <div class="profile-description-avatar">
      <img :src="avatarImage()" alt="Avatar" />
    </div>
    <p class="profile-description-name">
      {{ user.displayName }}
    </p>
    <p class="profile-description-description">
      {{ user.description }}
    </p>
    <div class="profile-description-address profile-info">
      <img
        class="profile-description-address-icon address-img"
        src="@/Common/Icons/CopyAddress.png"
        alt="Copy"
        @click="copyToClipboard(walletAddress)"
      />
      <div class="info-hover address-hover">Copy address</div>
      <p class="profile-description-address-text">
        {{ shortenedWalletAddress() }}
      </p>
    </div>
    <div class="profile-description-website profile-info">
      <img
        class="profile-description-website-icon website-img"
        src="@/Common/Icons/Website.png"
        alt="Website"
        @click="copyToClipboard(user.websiteUrl)"
      />
      <div class="info-hover website-hover">Copy website</div>
      <p class="profile-description-website-text">
        {{ user.websiteUrl || "No information" }}
      </p>
    </div>
    <div class="profile-description-address profile-info">
      <img
        class="profile-description-twitter-icon twitter-img"
        src="@/Common/Icons/TwitterAvatar.png"
        alt="Twitter"
        @click="copyToClipboard(user.twitterUsername)"
      />
      <div class="info-hover twitter-hover">Copy twitter</div>
      <p class="profile-description-twitter-text">
        {{ user.twitterUsername || "No information" }}
      </p>
    </div>
    <div class="profile-description-button-controls">
      <app-button
        buttonClass="edit-profile-button"
        text="Edit profile"
        @click.prevent="goToProfileEditForm()"
      ></app-button>
    </div>
    <!-- <hr class="horizontal-separator" /> -->
    <!-- <div class="profile-statistics">
      <p class="profile-statistics-title">Wallet balance</p>
      <div class="profile-statistics-content">
        <div class="wallet-value">
          {{ parseFloat(walletBalance || "0").toFixed(3) }}
        </div>
        <div class="wallet-currency">theos</div>
      </div>
      <app-button class="buy-theos-button" text="Buy THEOS"></app-button>
    </div> -->
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import AppButton from "@/elements/AppButton";
import useUserProfile from "@/composables/useUserProfile";
import useUtilities from "@/composables/useUtilities";

export default {
  components: {
    AppButton,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const store = useStore();
    onMounted(() => {
      store.dispatch("userProfile/fetchMe");
    });
    const router = useRouter();
    const goToProfileEditForm = () => router.push("/edit-profile");
    const {
      shortenedWalletAddress,
      walletAddress,
      walletBalance,
      getUserProperty,
      avatarImage,
    } = useUserProfile(store);
    const { copyToClipboard } = useUtilities();
    return {
      shortenedWalletAddress,
      walletBalance,
      getUserProperty,
      copyToClipboard,
      walletAddress,
      goToProfileEditForm,
      avatarImage,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profileDescription.scss"></style>
